let server = MAIN_SERVER_URL;

export default server

